(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["block-50-50"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fifty-block')) {
    customElements.define(
      'fifty-block',
      class FiftyBlock extends HTMLElement {
        constructor() {
          super();
          this.resizeObserver = null;
          this.intersectionObserver = null;
          this.image = null;
        }

        connectedCallback() {
          this.image = this.querySelector('.block-50-50__image-wrapper img');
          if (!this.image) return;

          this.updateHeight();

          // Update on image load
          this.image.addEventListener('load', () => this.updateHeight());

          // Update on resize
          this.resizeObserver = new ResizeObserver(() => this.updateHeight());
          this.resizeObserver.observe(this.image);

          // Scroll animation for mobile
          this.setupScrollAnimation();
        }

        disconnectedCallback() {
          if (this.resizeObserver) {
            this.resizeObserver.disconnect();
          }
          if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
          }
        }

        updateHeight() {
          if (!this.image) return;
          const height = this.image.offsetHeight;
          this.style.setProperty('--right-container-height', `${height}px`);
        }

        setupScrollAnimation() {
          const animationMobile = this.dataset.animationMobile;

          if (animationMobile !== 'animate_on_scroll') return;

          this.intersectionObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                // Only apply on mobile (< 768px)
                if (window.innerWidth >= 768) return;

                if (entry.isIntersecting) {
                  this.classList.add('is-visible-mobile');
                }
              });
            },
            {
              threshold: 0.3,
              rootMargin: '0px',
            }
          );

          this.intersectionObserver.observe(this);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gender-toggle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gender-toggle')) {
    customElements.define(
      'gender-toggle',
      class GenderToggle extends HTMLElement {
        constructor() {
          super();
          this.onClick = this.onClick.bind(this);
          this.onBlockSelect = this.onBlockSelect.bind(this);
        }

        connectedCallback() {
          this.section = this.closest('.shopify-section');
          this.addEventListener('click', this.onClick);
          if (window.Shopify?.designMode) {
            document.addEventListener('shopify:block:select', this.onBlockSelect);
          }
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        onClick(event) {
          const option = event.target.closest('[data-gender-option]');
          if (option) this.select(option.dataset.genderOption);
        }

        onBlockSelect(event) {
          if (!this.section || this.section.id !== `shopify-section-${event.detail?.sectionId}`) return;

          const target =
            event.target instanceof Element && this.section.contains(event.target)
              ? event.target
              : this.section.querySelector(`[block-id="${event.detail?.blockId}"]`);
          const gender = target?.closest('[data-gender]')?.dataset.gender;

          if (gender === 'men' || gender === 'women') this.select(gender);
        }

        select(gender) {
          if (this.dataset.active === gender) return;

          this.dataset.active = gender;
          this.querySelectorAll('[data-gender-option]').forEach((option) => {
            option.setAttribute('aria-pressed', String(option.dataset.genderOption === gender));
          });

          this.section?.querySelectorAll(`[data-gender="${gender}"]`).forEach((content) => {
            const carousels = content.matches('swiper-carousel')
              ? [content]
              : content.querySelectorAll('swiper-carousel');
            carousels.forEach((carousel) => carousel.swiperInstance?.update());
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["scrolling-ticker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scrolling-ticker')) {
    customElements.define(
      'scrolling-ticker',
      class ScrollingTicker extends HTMLElement {
        constructor() {
          super();
          this.track = null;
          this.resizeObserver = null;
        }

        connectedCallback() {
          this.track = this.querySelector('.scrolling-ticker-track');
          if (!this.track) return;

          // Wait for fonts and images to load before calculating
          if (document.readyState === 'complete') {
            this.duplicateElements();
          } else {
            window.addEventListener('load', () => this.duplicateElements());
          }

          this.resizeObserver = new ResizeObserver(() => {
            this.duplicateElements();
          });
          this.resizeObserver.observe(this);
        }

        disconnectedCallback() {
          if (this.resizeObserver) {
            this.resizeObserver.disconnect();
          }
        }

        duplicateElements() {
          const track = this.track;
          if (!track) return;

          // Remove previously cloned elements
          track.querySelectorAll('[data-cloned]').forEach((el) => el.remove());

          // Get original elements
          const originalElements = Array.from(track.querySelectorAll('.scrolling-ticker-element:not([data-cloned])'));
          if (originalElements.length === 0) return;

          // Get gap from computed styles
          const computedStyle = getComputedStyle(track);
          const gap = parseFloat(computedStyle.gap) || 0;

          // Calculate total width of original elements including gaps
          let originalWidth = 0;
          originalElements.forEach((el) => {
            originalWidth += el.offsetWidth;
          });
          // Add gaps between elements
          originalWidth += gap * originalElements.length;

          // Get container width
          const containerWidth = this.offsetWidth;

          // If no width yet, try again later
          if (originalWidth === 0 || containerWidth === 0) {
            requestAnimationFrame(() => this.duplicateElements());
            return;
          }

          // Calculate how many times we need to duplicate to fill at least 2x the container
          const timesToDuplicate = Math.max(1, Math.ceil((containerWidth * 2) / originalWidth));

          // Duplicate elements
          for (let i = 0; i < timesToDuplicate; i++) {
            originalElements.forEach((el) => {
              const clone = el.cloneNode(true);
              clone.setAttribute('data-cloned', 'true');
              clone.removeAttribute('id');
              clone.setAttribute('aria-hidden', 'true');
              track.appendChild(clone);
            });
          }

          // Force reflow to restart animation
          track.style.animation = 'none';
          track.offsetHeight; // Trigger reflow
          track.style.animation = '';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["social-feed"] && !Shopify.designMode) return;
  try {
    class SocialFeed extends HTMLElement {
    constructor() {
      super();

      this.feedId = this.dataset.feedId;
      this.maxItems = this.dataset.maxItems || 7;

      if (this.feedId) {
        this.loadFeed();
      }
    }

    async loadFeed() {
      try {
        const response = await fetch(`https://shopify.covet.pics/api/v1/embed/${this.feedId}`);
        const data = await response.json();
        if (data.items.length > 0) {
          this.renderFeed(data.items);
        }
      } catch (error) {
        console.error('Error loading social feed:', error);
      }
    }

    renderFeed(items) {
      const maxItems = Math.min(items.length, this.maxItems);

      for (let i = 0; i < maxItems; i++) {
        const item = items[i];
        const itemDiv = document.createElement('div');
        itemDiv.className = 'blocks-grid-item';

        if (i === 0) {
          itemDiv.style.cssText =
            '--blocks-grid-item-col-span-desktop: 6;--blocks-grid-item-col-span-mobile: 12;--blocks-grid-item-row-span-desktop: 2;--blocks-grid-item-border-radius-mobile: 8px;--blocks-grid-item-border-radius-desktop: 8px;--blocks-grid-item-overflow-mobile: hidden;--blocks-grid-item-overflow-desktop: hidden;--padding-desktop: 0px;--padding-mobile: 0px;';
        } else if (i > 0 && i < 4) {
          itemDiv.style.cssText = `--blocks-grid-item-col-span-desktop: 2;--blocks-grid-item-col-span-mobile: 6;--blocks-grid-item-border-radius-mobile: 8px;--blocks-grid-item-border-radius-desktop: 8px; --blocks-grid-item-row-start-mobile: auto;--blocks-grid-item-row-start-desktop: 1;--blocks-grid-item-row-span-mobile: auto;--blocks-grid-item-row-span-desktop: 1;--blocks-grid-item-overflow-mobile: hidden;--blocks-grid-item-overflow-desktop: hidden;--blocks-grid-item-col-start-desktop: ${
            i * 2 + 5
          };--padding-desktop: 0px;--padding-mobile: 0px;`;
        } else if (i > 3 && i < 7) {
          itemDiv.style.cssText = `--blocks-grid-item-col-span-desktop: 2;--blocks-grid-item-col-span-mobile: 6;--blocks-grid-item-border-radius-mobile: 8px;--blocks-grid-item-border-radius-desktop: 8px; --blocks-grid-item-row-start-mobile: auto;--blocks-grid-item-row-start-desktop: 2;--blocks-grid-item-row-span-mobile: auto;--blocks-grid-item-row-span-desktop: 1;--blocks-grid-item-overflow-mobile: hidden;--blocks-grid-item-overflow-desktop: hidden;--blocks-grid-item-col-start-desktop: ${
            (i - 3) * 2 + 5
          };--padding-desktop: 0px;--padding-mobile: 0px;`;
        }

        const picture = document.createElement('picture');
        picture.className = 'image-block-picture';

        if (i == 0) {
          picture.style.cssText =
            '--image-ratio: 922/612; --image-ratio-mobile: 922/612;--image-fit: cover;--image-fit-mobile: cover;';
        } else {
          picture.style.cssText =
            '--image-ratio: 1/1;--image-ratio-mobile: 1/1;--image-fit: cover;--image-fit-mobile: cover;';
        }

        const img = document.createElement('img');
        img.className = 'image-block__image';
        img.src = i === 0 ? item.images.high_resolution : item.images.medium_resolution;
        img.alt = item.images.alt_tag || '';

        picture.appendChild(img);
        itemDiv.appendChild(picture);
        this.appendChild(itemDiv);
      }
    }
  }

  customElements.define('social-feed', SocialFeed);
  } catch(e) { console.error(e); }
})();

})();
